import { NavLink, Outlet } from "react-router-dom";
import { EMPLOYEE_NAV } from "@/config/navigation";
import { Logo } from "@/components/brand/Logo";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useI18n } from "@/i18n/I18nProvider";

export default function EmployeeLayout() {
  const { t } = useI18n();
  return (
    <div className="min-h-[100dvh] bg-[#F8FAFC]">
      <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-[#E5E7EB] bg-white/95 px-4 backdrop-blur-md">
        <Logo size="sm" testId="portal-header-logo" />
        <LanguageToggle testIdPrefix="portal-lang" />
      </header>
      <main className="mx-auto w-full max-w-xl px-4 pb-28 pt-6">
        <Outlet />
      </main>
      <nav
        data-testid="employee-bottom-nav"
        className="fixed inset-x-0 bottom-0 z-30 border-t border-[#E5E7EB] bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md"
      >
        <div className="mx-auto flex h-16 max-w-xl items-stretch justify-around">
          {EMPLOYEE_NAV.map((item) => (
            <NavLink
              key={item.key}
              to={item.path}
              end={item.path === "/portal"}
              data-testid={`portal-nav-${item.key}`}
              aria-label={t(`portal.${item.key}`)}
              className={({ isActive }) =>
                `relative flex flex-1 flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors ${
                  isActive ? "text-[#000B45]" : "text-gray-500 hover:text-[#000B45]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && <span className="absolute top-0 h-1 w-8 rounded-b-full bg-[#FEB601]" />}
                  <item.icon className="h-5 w-5" />
                  {t(`portal.${item.key}`)}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
